import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import { useLocation } from '@reach/router'
import { css } from 'linaria'
import Menu from '~/components/Backgroundcheck/Menu'
import SmoothScroll from '~/components/Common/SmoothScroll'
import imageLogoWhite from '~/images/logo-white.svg'
import { STYLE } from '~/utils/constant'
import { rem } from '~/utils/helper'

const headerStyle = css`
  height: 0;

  & > .inner {
    position: fixed;
    z-index: var(--zindex-header);
    top: 0;
    right: 0;
    left: 0;
    transform: translateY(-100%);
    transition: transform 0.48s var(--transition-md) 0s, background-color 0.24s var(--transition-md) 0s;
    background: rgb(var(--color-background-bright) 0);
    will-change: background;

    &.-is-scrolled {
      background: var(--color-background-bright);
    }

    &.-is-menu-show {
      background: var(--color-background-gray);

      @media screen and (${STYLE.MEDIA.TABLET}) {
        background: var(--color-background-bright);
      }
    }

    &.-is-menu-show,
    &.-is-header-show {
      transform: translateY(0);
    }
  }

  & > .inner > .body {
    display: flex;
    align-items: center;
    max-width: var(--width-max);
    height: var(--height-header);
    margin-right: auto;
    margin-left: auto;
    padding-right: 24px;
    padding-left: 24px;

    @media screen and (${STYLE.MEDIA.PC}) {
      height: var(--height-header-pc);
      padding-right: 32px;
      padding-left: 32px;
    }
  }

  & > .inner > .body > .logowrapper {
    display: block;
    position: relative;
    z-index: var(--zindex-header-logo);
    margin-left: -8px;
  }

  & > .inner > .body > .logowrapper > .button {
    display: block;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      backface-visibility: hidden;
      transition: opacity 0.24s var(--transition-md) 0s;
      opacity: 1;
      background: url(${imageLogoWhite}) left top no-repeat;
      background-size: contain;
    }
  }

  & > .inner.-is-scrolled > .body > .logowrapper > .button,
  & > .inner > .body > .logowrapper.-is-menu-show > .button {
    &::before {
      opacity: 0;
    }
  }

  & > .inner > .body > .logowrapper > .button > .logo {
    display: block;
    width: 150px;
    height: auto;
    backface-visibility: hidden;
    transition: opacity 0.24s var(--transition-md) 0s;
    opacity: 0;

    @media screen and (${STYLE.MEDIA.PC}) {
      width: 180px;
    }
  }

  & > .inner > .body > .logowrapper.-is-menu-show > .button > .logo,
  & > .inner.-is-scrolled > .body > .logowrapper > .button > .logo {
    opacity: 1;
  }

  & > .inner > .body > .navigationContent {
    flex-grow: 1;
  }

  /* stylelint-disable-next-line no-descending-specificity */
  & > .inner > .body > .navigationContent > .button {
    position: absolute;
    top: 0;
    right: 24px;
    bottom: 0;
    width: 40px;
    height: 40px;
    margin-top: auto;
    margin-bottom: auto;
    padding: 0;
    overflow: hidden;
    border: 0;
    border-radius: 50%;
    background-color: var(--color-background-gray50);
    text-indent: 100%;
    white-space: nowrap;

    @media screen and (${STYLE.MEDIA.HEADER_SHORT}) {
      right: 32px;
    }

    @media screen and (${STYLE.MEDIA.HEADER_WIDE}) {
      display: none;
    }
  }

  & > .inner > .body > .navigationContent > .button > .icon {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 20px;
    height: 2px;
    margin: auto;
    border-radius: 2px;
    background-color: var(--color-border-black);

    &::before,
    &::after {
      content: '';
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      width: 20px;
      height: 2px;
      border-radius: 2px;
      background-color: var(--color-border-black);
    }

    &::before {
      top: -6px;
    }

    &::after {
      top: 6px;
    }
  }

  & > .inner > .body > .navigationContent.-is-show > .button > .icon {
    background-color: transparent;

    &::before {
      top: 0;
      transform: rotate(-45deg);
    }

    &::after {
      top: 0;
      transform: rotate(45deg);
    }
  }

  & > .inner > .body > .navigationContent.-is-show > .navigation {
    opacity: 1;
    pointer-events: auto;
    overscroll-behavior-y: contain;
  }

  & > .inner > .body > .navigationContent > .navigation > .items {
    display: none;
    position: relative;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding-top: 0;
    padding-bottom: 0;

    @media screen and (${STYLE.MEDIA.HEADER_SHORT}) {
      display: flex;
      margin-right: 62px;
    }

    @media screen and (${STYLE.MEDIA.PC}) {
      margin-right: 54px;
    }

    @media screen and (${STYLE.MEDIA.HEADER_WIDE}) {
      margin-right: 0;
    }
  }

  & > .inner > .body > .navigationContent > .navigation > .items > .item {
    &.-top {
      display: none;

      @media screen and (${STYLE.MEDIA.HEADER_MIDDLE}) {
        display: block;
      }
    }
  }

  & > .inner > .body > .navigationContent > .navigation > .items > .item > .button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 32px;
    margin-top: 0;
    margin-left: 24px;
    color: var(--color-text-bright);
    font-size: ${rem(14)};
    font-weight: 700;
    letter-spacing: 0;
    text-decoration: none;

    &.-inquiry,
    &.-request {
      height: 40px;
      margin-left: 16px;
      padding-right: 24px;
      padding-right: 16px;
      padding-left: 16px;
      border: 1px solid transparent;
      border-radius: 100px;
      border-color: var(--color-border-bright);
    }

    &.-inquiry {
      background-color: none;
      color: var(--color-text-bright);
    }

    &.-request {
      background-color: var(--color-background-bright);
      color: var(--color-text-link);
    }
  }

  & > .inner > .body > .navigationContent.-is-show > .navigation > .items > .item > .button {
    color: var(--color-text);

    &.-inquiry {
      border-color: var(--color-border-key);
      color: var(--color-key);
    }

    &.-request {
      border-color: var(--color-border-key);
      background-color: var(--color-background-key);
      color: var(--color-text-bright);
    }
  }

  & > .inner > .body > .navigationContent > .navigation > .items > .item > .button > .icon {
    width: 1em;
    height: auto;
    margin-right: 8px;
  }

  & > .inner > .body > .navigationContent > .navigation > .items > .item > .button > .icon path {
    fill: currentColor;
  }

  /* stylelint-disable-next-line no-descending-specificity */
  & > .inner.-is-scrolled .navigationContent > .navigation > .items > .item > .button,
  & > .inner.-is-scrolled .navigationContent.-is-show .navigation > .items > .item > .button {
    color: var(--color-text);
    /* stylelint-disable-next-line no-descending-specificity */
    &.-inquiry {
      border-color: var(--color-border-key);
      color: var(--color-key);
    }
    /* stylelint-disable-next-line no-descending-specificity */
    &.-request {
      border-color: var(--color-border-key);
      background-color: var(--color-background-key);
      color: var(--color-text-bright);
    }
  }
`

const HeaderBackgroundcheckComponent = () => {
  const { pathname } = useLocation()
  const isTopPage = pathname === '/backgroundcheck'
  const [isMenuShow, setMenuShow] = useState(false)
  const [isScrolled, setScrolled] = useState(!isTopPage)
  const [isHeaderShow, setHeaderShow] = useState(true)

  const hideMenu = () => {
    setMenuShow(false)
  }

  let set_position = 0

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY < 10 || set_position > document.documentElement.scrollTop) {
        setHeaderShow(true)
      } else {
        setHeaderShow(false)
      }
      set_position = document.documentElement.scrollTop

      if (isTopPage && window.scrollY < 10) {
        setScrolled(false)
      } else {
        setScrolled(true)
      }
    })
  }, [])

  return (
    <header className={headerStyle}>
      <div
        className={`inner${isMenuShow ? ' -is-menu-show' : ''}${isHeaderShow ? ' -is-header-show' : ''}${
          isScrolled ? ' -is-scrolled' : ''
        }`}
      >
        <div className="body">
          <div className={isMenuShow ? 'logowrapper -is-menu-show' : 'logowrapper'}>
            <Link to="/" className="button" onClick={() => setMenuShow(false)}>
              <StaticImage
                className="logo"
                src="../../images/logo.svg"
                objectFit="contain"
                objectPosition="center center"
                placeholder="none"
                alt="リファレンスチェックサービス en ASHIATO"
              />
            </Link>
          </div>

          <div className={isMenuShow ? 'navigationContent -is-show' : 'navigationContent'}>
            <nav className="navigation">
              <ul className="items">
                <li className="item -top">
                  <Link to="/" className="button">
                    リファレンスチェック
                  </Link>
                </li>
                <li className="item">
                  <Link to="/inquiry" className="button -inquiry" onClick={() => setMenuShow(false)}>
                    お問い合わせ
                  </Link>
                </li>
                <li className="item">
                  <SmoothScroll
                    className="button -request"
                    to="request"
                    href="/backgroundcheck/#request"
                    onClick={() => setMenuShow(false)}
                  >
                    資料ダウンロード
                  </SmoothScroll>
                </li>
              </ul>
            </nav>
            <button className="button" type="button" onClick={() => setMenuShow(!isMenuShow)}>
              <span className="icon" />
              Menu
            </button>
          </div>
        </div>
      </div>
      <Menu isMenuShow={isMenuShow} hideMenu={hideMenu} />
    </header>
  )
}

export default HeaderBackgroundcheckComponent
